import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";
import Iconify from "../iconify/Iconify";
import { REWARD_TYPES } from "src/utils/rewardTypesUtils";

const convertRewardType = (type) => REWARD_TYPES[type] || "Unknown";
const convertRewardSource = (source) => {
  switch (source) {
    case 0:
      return "Coins";
    case 1:
      return "XP";
    default:
      return "Unknown";
  }
};
export default function RewardsTable(props) {
  console.log("props", props);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Transaction ID</TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Reward</TableCell>
            <TableCell>Is New</TableCell>
            <TableCell>Updated At</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.rewards?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.rewardId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.userId}
              </TableCell>

              <TableCell component="th" scope="row">
                {convertRewardType(row.rewardType)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.rewardAmount} {convertRewardSource(row.rewardSource)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.isNew ? (
                  <Iconify
                    icon={"eva:checkmark-circle-2-outline"}
                    sx={{ color: "green" }}
                  />
                ) : (
                  <Iconify
                    icon={"eva:close-circle-outline"}
                    sx={{ color: "red" }}
                  />
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.updatedAt.substring(0, 10)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.createdAt.substring(0, 10)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
